// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__30gk0","shape":"Tooltip_shape__mRiUu","wrapper":"Tooltip_wrapper__dXrDF","position":"Tooltip_position__xzwKw"};